// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient-yellow[data-v-38d51cf2]{background:#ffdb78;background:linear-gradient(90deg,rgba(255,219,120,.8),rgba(73,73,73,.9))}.quote[data-v-38d51cf2]{font-size:80px;font-style:italic;line-height:.7em;margin-top:calc(10vw + 390px)}@media (min-width:1024px){.quote[data-v-38d51cf2]{font-size:100px;left:calc(30% + 130px);margin-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
